<template>
  <div :class="inlineClasses">
    <div class="form-label" :class="labelClasses">{{ label }}</div>
    <div v-if="richText" id="editor-wrapper" class="w-full mt-1 ml-2" @mouseleave="onFocusOut">
      <div v-if="simpleEditor" id="editor-tools" class="inline-flex w-full bg-gray-200 p-1">
        <button @click="applyTag('B')" title="Bold"
                class="bg-gray-400 hover:bg-gray-500 text-gray-800 font-bold py-2 px-4 rounded-l"><b>B</b></button>
        <button @click="applyTag('I')" title="Italic"
                class="bg-gray-400 hover:bg-gray-500 text-gray-800 font-bold py-2 px-4"><i>I</i></button>
        <button @click="applyTag('U')" title="Underline"
                class="bg-gray-400 hover:bg-gray-500 text-gray-800 font-bold py-2 px-4"><u>U</u></button>
        <button @click="applyTag('S')" title="Strike"
                class="bg-gray-400 hover:bg-gray-500 text-gray-800 font-bold py-2 px-4"><s>S</s></button>
        <button @click="applyTag('X')" title="Clear formatting"
                class="bg-gray-400 hover:bg-gray-500 text-gray-800 font-bold py-2 px-4 rounded-r"><b><i>C</i></b>
        </button>
      </div>
      <div :id="id"
           :contenteditable="!readOnly"
           class="form-input w-full h-24 max-h-full overflow-y-scroll resize-y"
           :class="extraClasses"
           ref="textarea"
           :disabled="disabled"
           v-html="myValue"
           @blur="onFocusOut"
      ></div>
    </div>
    <textarea v-if="!richText"
              :name="id"
              :id="id"
              :cols="cols"
              class="mt-1 form-input w-full"
              :class="extraClasses"
              :rows="rows"
              ref="textarea"
              v-model="myValue"
              :placeholder="placeholder"
              :disabled="disabled"
              :readonly="readOnly"></textarea>
    <field-error-help-length :error="error" :help="help" :input-length="myValue.length"
                             :max-length="maxLength"></field-error-help-length>
  </div>
</template>
<script>
export default {
  name: "my-textarea",
  props: {
    error: {type: String},
    help: {type: String},
    id: {type: String},
    label: {type: String},
    maxLength: {type: Number, default: 0},
    placeholder: {type: String, default: ''},
    cols: {type: Number, default: 30},
    rows: {type: Number, default: 10},
    value: {type: String},
    inline: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    readOnly: {type: Boolean, default: false},
    richText: {type: Boolean, default: false},
    simpleEditor: {type: Boolean, default: false},
  },
  data() {
    return {
      myValue: this.value,
    }
  },
  computed: {
    labelClasses() {
      return this.inline ? 'w-1/3 whitespace-nowrap' : '';
    },
    inlineClasses() {
      return this.inline ? 'flex mb-4 justify-center items-center' : '';
    },
    extraClasses() {
      let classes = this.error ? 'form-error' : '';
      classes += this.readOnly || this.disabled ? ' bg-gray-300 text-gray-500 resize-y' : '';
      return classes;
    }
  },
  watch: {
    value() {
      this.myValue = this.value;
    },
    myValue() {
      this.$emit('textarea', this.myValue);
      this.$emit('update:value', this.myValue);
    }
  },
  methods: {
    focus() {
      this.$refs.textarea.focus();
    },
    onFocusOut() {
      this.myValue = this.$refs.textarea.innerHTML;
    },
    applyTag(tag) {
      let text = "";
      let formatted = "";
      if (window.getSelection) {
        text = window.getSelection().toString();
      } else if (document.selection && document.selection.type != "Control") {
        text = document.selection.createRange().text;
      }
      switch (tag) {
        case 'B':
          formatted = '<b>' + text + '</b>';
          break;
        case 'I':
          formatted = '<i>' + text + '</i>';
          break;
        case 'S':
          formatted = '<s>' + text + '</s>';
          break;
        case 'U':
          formatted = '<u>' + text + '</u>';
          break;
      }
      if (tag !== 'X') {
        this.myValue = this.myValue.replace(text, formatted);
      } else {
        let html = this.myValue;
        let div = document.createElement("div");
        div.innerHTML = html;
        this.myValue = div.textContent || div.innerText || "";
      }
    }
  }
}
</script>